import React from "react";
import { CheckCircle, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { checkUserPermissions } from "@/utils/checkUserPermissions";
import { accessTitanversePrescriptionApproval } from "@/data/constantStrings";
import {
  setShowPermissionModal,
  setShowPermissionMessage,
} from "@/dispatchers/appDispatchers";
interface PrescriptionApprovalBulkActionsProps {
  isDarkMode: boolean;
  selectedCount: number;
  onBulkApprove: () => void;
  onClearSelection: () => void;
}

export function PrescriptionApprovalBulkActions({
  isDarkMode,
  selectedCount,
  onBulkApprove,
  onClearSelection,
}: PrescriptionApprovalBulkActionsProps) {
  if (selectedCount === 0) return null;
  const canViewPrescription = checkUserPermissions(
    accessTitanversePrescriptionApproval,
  );
  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div
        className={`flex items-center gap-4 px-6 py-4 rounded-lg shadow-lg border ${
          isDarkMode
            ? "bg-gray-800 border-gray-700 text-white"
            : "bg-white border-gray-200 text-gray-900"
        }`}
      >
        <div className="flex items-center gap-2">
          <CheckCircle className="w-5 h-5 text-blue-600" />
          <span className="font-medium">
            {selectedCount} prescription
            {selectedCount !== 1 ? "s" : ""} selected
          </span>
        </div>

        <div className="h-6 w-px bg-gray-300" />

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={() => {
              if (!canViewPrescription) {
                setShowPermissionMessage("Approval Prescription");
                setShowPermissionModal(true);
                return;
              }

              onBulkApprove();
            }}
            className={`bg-blue-600 hover:bg-blue-700 text-white ${
              !canViewPrescription ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <Settings className="w-4 h-4 mr-1" />
            Process All
          </Button>

          <Button
            size="sm"
            variant="ghost"
            onClick={onClearSelection}
            className={`${
              isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
            }`}
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
}
